<template>
  <div class="container">
    <!--UPLOAD-->
    <form enctype="multipart/form-data" novalidate>
      <div :class="['dropbox', appeal.missingUpload ? 'missing' : '']" v-if="appeal">
        <input
          type="file"
          multiple
          :disabled="isSaving"
          @change="filesChange($event.target.files)"
          accept=".pdf,image/*,.doc,.docx,.pptx,.ppt,.mp4,.mov"
          class="input-file"
        />
        <p v-if="!isSaving">
          {{ $t('drag-to-upload') }} <span class="select-files">{{ $t('select-files') }}</span>
        </p>
        <p v-if="isSaving">{{ $t('uploading-file') }}</p>
      </div>
      <div v-if="asset" class="upload-container">
        <input
          :id="`fileUpload-${asset.id}`"
          type="file"
          :disabled="isSaving"
          @change="filesChange($event.target.files)"
          accept=".pdf,image/*,.doc,.docx,.pptx,.ppt,.mp4,.mov"
          class="input-file"
          hidden
        />
        <button v-if="!isSaving" @click="chooseFile(asset)" type="button">
          {{ $t('upload-new-file') }}
        </button>
        <button disabled v-if="isSaving" type="button">Currently Uploading</button>
      </div>
    </form>
    <div class="success" v-if="isSuccess && appeal">
      <div class="flex-row" v-for="upload in uploadedFiles" :key="upload.index">
        <span>{{ upload.file }}</span>
        <a class="relative" target="_blank" :href="upload.url">
          <img class="download-icon" src="@/assets/img/download-arrow.png" />
        </a>
        <Remove class="remove" @click="removeFile(upload)" />
      </div>
    </div>
  </div>
</template>

<script>
import Remove from '@/assets/icons/delete-icn.svg';

const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_FAILED = 3;
export default {
  name: 'Upload',
  components: {
    Remove,
  },
  props: {
    appeal: {
      type: Object,
      required: false,
      default: null,
    },
    asset: { Object, required: false, default: null },
    isSurveyInterference: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      return this.currentStatus === STATUS_FAILED;
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = null;
    },
    save(file) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;
      const types = file.type;
      const params = { fileName: file.name, contentType: types };
      const { appeal, asset } = this;
      let uploadUrl = '';
      if (this.appeal && !this.isSurveyInterference) {
        uploadUrl = 'uploadItem';
      }
      if (this.asset) {
        uploadUrl = 'uploadAsset';
        params.assetTitle = asset.assetTitle;
        params.domain = asset.domain;
      }
      if (this.isSurveyInterference) {
        uploadUrl = 'uploadAttachment';
      }

      this.$store
        .dispatch(uploadUrl, { params, file })
        .then((res) => {
          if (this.appeal) {
            this.$emit('sendurl', { res, appeal });
          }
          if (this.asset) {
            this.$emit('sendurl', { res, asset });
          }
          this.currentStatus = STATUS_SUCCESS;
        })
        .catch((error) => {
          this.uploadedFiles = [];
          this.uploadError = error.response;
          this.currentStatus = STATUS_FAILED;
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error.response.data.error,
          });
        });
    },
    filesChange(files) {
      files.forEach((file) => {
        if (this.fileNameValidation(file.name)) {
          this.uploadedFiles.push({ file: file.name, url: URL.createObjectURL(file) });
          this.save(file);
        } else {
          alert(this.$t('incompatible-filename-on-upload'));
        }
      });
    },
    fileNameValidation(fileName) {
      const re = /^[0-9a-zA-Z_\-& ... ]+$/;
      return re.test(fileName);
    },
    removeFile(selectedFile) {
      this.uploadedFiles.forEach((file, index) => {
        if (file.file === selectedFile.file) {
          this.uploadedFiles.splice(index, 1);
        }
      });
      this.$emit('removeUpload', selectedFile);
    },
    chooseFile(asset) {
      document.getElementById(`fileUpload-${asset.id}`).click();
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: 0 -10px;
  color: dimgray;
  position: relative;
  cursor: pointer;
  height: 58px;
}

.missing {
  outline-color: red !important;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 60px;
  position: absolute;
  cursor: pointer;
  left: 0;
}

.dropbox p {
  font-size: 1em;
  text-align: center;
  padding: 20px 0;
}

.success {
  margin-top: 20px;
}
.remove {
  height: 15px;
  width: 15px;
  margin-left: 10px;
  cursor: pointer;
}
.flex-row {
  align-items: center;
}
.upload-container {
  button {
    min-width: 220px;
    max-width: 220px;
  }
}
.select-files {
  text-decoration: underline;
  color: $primary;
}
</style>
